export default function XiaohongshuIcon({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fontFamily="'Noto Serif SC', serif"
        fontSize="15"
        fontWeight="700"
        fill="#FDFBF7"
      >
        红
      </text>
    </svg>
  );
}
